import { motion } from "framer-motion";
// import { motion, useAnimation} from "framer-motion";
// import { useEffect } from "react";
// import { useInView } from 'react-intersection-observer';


 
export default function TypingLetters({ text }){
    const characters = text.split("");
    // const controls = useAnimation();
    // const[ref, inView] = useInView({threshold: 0.5})
   
    
    // useEffect(()=> {
    //     if(inView) {
    //         controls.start({
    //             opacity: 1
    //         })
    //     }
    // }, [controls, inView])

    return(
        // <div ref={ref}>
            <div>
            {/* <motion.div className={inView ? "typing-text" : null}    > */}
            <motion.div className="typing-text"   >
                {characters.map((character, i) => (
                        <motion.span
                            // ref={ref}
                            initial={{
                                opacity: 0
                            }}
                            // animate={controls}
                            animate={{
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.1,
                                delay: i/20,
                                type: "spring",
                                
                                
                            
                            }}
                            key={i}
                        >
                            {character}
                        </motion.span>
                ))} 
            </motion.div>
        </div>
    );


}